/**
 * AuditLogIcon — A scroll: the record of what each member did. Hugeicons scroll-01 (MIT).
 */

import svg from './svg/audit-log.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const AuditLogIcon = makeSvgIcon('audit-log', svg);
